import { render } from "./WheelAdminPanel.vue?vue&type=template&id=36d29978&scoped=true"
import script from "./WheelAdminPanel.vue?vue&type=script&lang=js"
export * from "./WheelAdminPanel.vue?vue&type=script&lang=js"

import "./WheelAdminPanel.vue?vue&type=style&index=0&id=36d29978&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d29978"]])

export default __exports__